import { useEffect } from "react";
import Privacy from "../components/Privacy";

interface PrivacyScreenProps {
  loaderStatus?: (status: boolean) => void;
}

const PrivacyScreen = ({ loaderStatus }: PrivacyScreenProps) => {
  // Static page: clear the global loading overlay on mount.
  useEffect(() => {
    loaderStatus?.(true);
  }, [loaderStatus]);

  return <Privacy />;
};

export default PrivacyScreen;
